
export function getJSON(url, headers = {}, successCallback, errorCallback) {
  const request = $.ajax({
    url: url,
    method: 'GET',
    dataType: 'json',
    headers: headers
  });

  // If callback provided, use it
  if (typeof successCallback === 'function') {
    request.done(successCallback);
  }

  if (typeof errorCallback === 'function') {
    request.fail(errorCallback);
  } else {
    request.fail(function(xhr, status, error) {
      console.error('Request failed:', status, error);
    });
  }

  // Return the jqXHR (promise-compatible)
  return request;
}


export function getBaseUrl(url, keywords = ["geoserver", "boc"]) {
  for (const key of keywords) {
    const regex = new RegExp(`^(.*?/${key}/)`);
    const match = url.match(regex);
    if (match) {
      return match[1];
    }
  }
  return url;
}


export function isImageFormat(legendFormat) {
  if (!legendFormat) return false;

  const format = legendFormat.toLowerCase();
  const imageTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif", "image/svg+xml"];

  return imageTypes.includes(format);
}